var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"__nav_item",attrs:{"href":_vm.url}},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_c('span',{class:{ __text: _vm.icon }},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }